import { uuid } from 'uuidv4'

var initial = {
    appType: '',
    appFee: 0,
    appId: '',
    data: {},
    states: [],
    nmo_states: [],
    qual: [],
    transaction: {},
    saved: false
}

const FormDataReducer = (state = initial, action) => {
    switch(action.type){
        case "SET_FORM_TYPE":
            state = { ...state, appType: action.payload }
            return state;
        case "SET_FORM_FEE":
            state = { ...state, appFee: action.payload }
            return state;
        case "SET_FORM_ID":
            state = { ...state, appId: uuid() }
            return state;
        case "SET_FORM_DATA":
            state= { ...state, data: action.payload }
            return state;
        case "SET_STATES":
            state = { ...state, states: action.payload }
            return state;
        case "SET_NMOSTATES":
            state = { ...state, nmo_states: action.payload }
            return state;
        case "SET_TRANSACTION":
            state = { ...state, transaction: action.payload }
            return state;
        case "SET_QUAL":
            state = { ...state, qual: action.payload }
            return state;
        case "FORM_SAVED":
            state = { ...state, saved: true }
            return state;
        default:
            return state;
    }
}

export default FormDataReducer;